var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfoIconDataSense(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 13,
    viewBox: "0 0 12 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.875 2.39844C3.01562 1.25781 4.39062 0.6875 6 0.6875C7.60938 0.6875 8.97656 1.25781 10.1016 2.39844C11.2422 3.52344 11.8125 4.89062 11.8125 6.5C11.8125 8.10938 11.2422 9.48438 10.1016 10.625C8.97656 11.75 7.60938 12.3125 6 12.3125C4.39062 12.3125 3.01562 11.75 1.875 10.625C0.75 9.48438 0.1875 8.10938 0.1875 6.5C0.1875 4.89062 0.75 3.52344 1.875 2.39844ZM6.67969 3.57031C6.49219 3.36719 6.26562 3.26562 6 3.26562C5.73438 3.26562 5.5 3.36719 5.29688 3.57031C5.10938 3.75781 5.01562 3.98438 5.01562 4.25C5.01562 4.51562 5.10938 4.75 5.29688 4.95312C5.5 5.14062 5.73438 5.23438 6 5.23438C6.26562 5.23438 6.49219 5.14062 6.67969 4.95312C6.88281 4.75 6.98438 4.51562 6.98438 4.25C6.98438 3.98438 6.88281 3.75781 6.67969 3.57031ZM7.3125 9.21875V8.65625C7.3125 8.46875 7.21875 8.375 7.03125 8.375H6.75V6.03125C6.75 5.84375 6.65625 5.75 6.46875 5.75H4.96875C4.78125 5.75 4.6875 5.84375 4.6875 6.03125V6.59375C4.6875 6.78125 4.78125 6.875 4.96875 6.875H5.25V8.375H4.96875C4.78125 8.375 4.6875 8.46875 4.6875 8.65625V9.21875C4.6875 9.40625 4.78125 9.5 4.96875 9.5H7.03125C7.21875 9.5 7.3125 9.40625 7.3125 9.21875Z",
    fill: "#19B5FE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoIconDataSense);
export default __webpack_public_path__ + "static/media/info-icon-data-sense.56afbcd5d47292e057b3687e89e2d271.svg";
export { ForwardRef as ReactComponent };